var _style, _rect, _path, _path2, _g, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenLinkBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 600",
    style: {
      enableBackground: "new 0 0 800 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.1,
    className: "st0",
    width: 800,
    height: 600
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.2,314.8l-17.6,17.6c-1.8,1.8-4.8,1.8-6.6,0c-1.8-1.8-1.8-4.8,0-6.6l15.9-15.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.9,289.9l17.2-17.2c1.8-1.8,4.8-1.8,6.6,0c1.8,1.8,1.8,4.8,0,6.6l-15.5,15.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 246.1,
    className: "st2",
    width: 5.4,
    height: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.4,
    y: 283.7,
    className: "st2",
    width: 21.5,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 254.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -77.3587 344.1695)",
    className: "st2",
    width: 5.4,
    height: 21.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 424.4,
    y: 331.6,
    className: "st2",
    width: 5.4,
    height: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.9,
    y: 310.1,
    className: "st2",
    width: 21.5,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.3,
    y: 322.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -104.7211 414.4709)",
    className: "st2",
    width: 5.4,
    height: 21.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.6,313.5c-10.2-1.9-21.2,1.1-29.1,9l-13.2,13.2c-12.8,12.8-12.8,33.6,0,46.4c12.8,12.8,33.6,12.8,46.4,0 l13.2-13.2c7.9-7.9,10.9-18.8,9-29.1c0.3-0.3,0.6-0.4,0.9-0.7l6.8-6.8c4.9,14.7,1.6,31.5-10.1,43.2l-13.2,13.2 c-16.4,16.5-43.1,16.5-59.6,0c-16.5-16.5-16.5-43.1,0-59.6l13.2-13.2c11.7-11.7,28.5-15,43.2-10.1l-6.8,6.8 C376.1,312.8,375.9,313.2,375.6,313.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499,276l-13.2,13.2c-11.7,11.7-28.5,15-43.2,10.1l6.8-6.8c0.3-0.3,0.5-0.6,0.7-0.9c10.2,1.9,21.2-1.1,29.1-9 l13.2-13.2c12.8-12.8,12.8-33.6,0-46.4c-12.8-12.8-33.6-12.8-46.4,0l-13.2,13.2c-7.9,7.9-10.9,18.8-9,29.1c-0.3,0.3-0.6,0.5-0.9,0.7 l-6.8,6.8c-4.9-14.7-1.6-31.5,10.1-43.2l13.2-13.2c16.4-16.4,43.1-16.4,59.6,0C515.5,232.9,515.5,259.5,499,276z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLinkBig);
export default __webpack_public_path__ + "static/media/broken_link_big.9c402143999a6b9bf8aa653dcf93eebb.svg";
export { ForwardRef as ReactComponent };